import { type FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { FormFeedback } from '../../components/Form/FormFeedback'
import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'
import { type InviteResponse, useDeleteInviteMutation } from '../../store/auth/auth'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { addToast } from '../../store/toast/toastSlice'

const FAILED = 'The request could not be revoked. Try again in a moment.'

export interface RevokeRequestModalProps {
  invite: InviteResponse
  onHide: () => void
}

export const RevokeRequestModal: FC<RevokeRequestModalProps> = ({ invite, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const dispatch = useAppDispatch()
  const { trackingClient } = useTracking()
  const [deleteInvite, { isLoading, isError }] = useDeleteInviteMutation()

  const handleRevoke = async () => {
    const result = await deleteInvite({ accountId, inviteId: invite.id })
    if ('error' in result) {
      return
    }
    trackingClient.track({ eventName: TrackEvent.INVITE_REVOKED, eventDetails: { email: invite.user.email } })
    dispatch(addToast({ variant: 'success', title: 'Request revoked.' }))
    onHide()
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Revoke requested invitation?</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>This request will be removed from the list.</div>
          {isError ? <FormFeedback>{FAILED}</FormFeedback> : null}
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      show
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions
      onFooterPrimaryAction={handleRevoke}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Revoke'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
